import React from 'react';

import { Typography, StackView, Paragraph, Divider } from '@telus-uds/components-web';

import EN from '../../EN.json';
import { ContentWrapper } from '../design/css';

const Expired = () => {
  const {
    contractSignature: {
      expiredPage: { header, message }
    }
  } = EN;

  return (
    <>
      <StackView space={4}>
        <Divider />
      </StackView>
      <div className="container 85%">
        <ContentWrapper>
          <StackView space={3}>
            <Typography heading="h2" variant={{ size: 'h2' }} block>{header}</Typography>
          </StackView>
          <Paragraph variant={{ bold: true }}>{message}</Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Expired;
